export default [
  // Centers
  {
    path: "/12e2905eb3f10f4c2ab20c90",
    children: [
      {
        path: "crtectrerfytyeyyeyer",
        name: "25.bece.centers",
        meta: {
          title: "2025 BECE CENTERS",
          authRequired: true,
          acc: ["y12838"],
        },
        component: () =>
          import("@/views/bece/twf/center_management/index.vue"),
      },
      // assign center
      {
        path: "149da1f4ac0c4f24eef214f6/:cn?",
        name: "bece25.center.create",
        meta: {
          title: "Create BECE 2025 center",
          authRequired: true,
          acc: ["y99931"],
        },
        component: () =>
          import("@/views/bece/twf/center_management/create.vue"),
      },
      // view center
      {
        path: "14352062b562ce0a5186fc73/:cn?",
        name: "bece25.center.view",
        meta: {
          title: "View BECE 2025 center",
          authRequired: true,
          acc: ["y19668"],
        },
        component: () => import("@/views/bece/twf/center_management/view.vue"),
      },
      //   {
      //     path: "hgnerugervbhoiuvervgye",
      //     name: "newCenters",
      //     meta: {
      //       title: "2025 BECE NEW CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/bece/twf/center_management/newCenters.vue"),
      //   },
      //   {
      //     path: "center_requests",
      //     name: "newCenterRequest",
      //     meta: {
      //       title: "2025 BECE NEW CENTERS Requests",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/bece/twf/center_management/requests.vue"),
      //   },
      //   {
      //     path: "center_request/:cn?",
      //     name: "CenterRequestv",
      //     meta: {
      //       title: "2025 BECE Requests Details",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/bece/twf/center_management/request.vue"),
      //   },
      //   {
      //     path: ":cn/edit_center",
      //     name: "editCenter",
      //     meta: {
      //       title: "EDIT CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/bece/twf/center_management/edit-center.vue"),
      //   },
      //   {
      //     path: ":cn/view_center",
      //     name: "viewCenters",
      //     meta: {
      //       title: "VIEW CENTERS",
      //       authRequired: true,
      //       acc: ["y17459"],
      //     },
      //     component: () =>
      //       import("../views/bece/twf/center_management/view-center.vue"),
      //   },
    ],
  },
];
